import { CareComponentConfig } from "./CareComponentConfig";

class FlowsheetConfig {
    public CareComponents: CareComponentConfig[];

    public constructor(init?: Partial<FlowsheetConfig>) {
        Object.assign(this, init);
    }
}

export { FlowsheetConfig };
